import {useEffect} from 'react'
import {FacebookMessageConfirmOrderTable} from '../table'
import {StyledFacebookMessageConfirmOrderWrapper} from './_styled'
import {ModalConfirmStatus} from "../modal";
import useFacebookMessageConfirmOrder from "../../hooks/useFacebookMessageConfirmOrder";

export const FacebookMessageConfirmOrderWrapper = ({...props}) => {
  const {data, methods} = useFacebookMessageConfirmOrder()
  const {confirmStatus} = data.modal
  useEffect(() => {
    methods.fetchOrigin()
  }, [])

  return (
    <StyledFacebookMessageConfirmOrderWrapper {...props}>
      <FacebookMessageConfirmOrderTable rows={data.pages.list} />
    {
        +confirmStatus?.data?.status === 1 && !!confirmStatus?.open
        && <ModalConfirmStatus
            open={confirmStatus?.open}
            onCancel={methods?.onCancel}
            onConfirm={methods?.onConfirm}
           />
    }
    </StyledFacebookMessageConfirmOrderWrapper>
  )
}
